export function ComponentMenu() {
  $('#button-toggle-menu').on('click', function (e) {
    e.preventDefault();

    $(this).toggleClass('active');
    $('#menu-main').toggleClass('active');
  });

  $('#index-image').on('click', function () {
    $('html, body').animate({
      scrollTop: $($('section').get(1)).offset().top - 100
    }, 1000);
  });
}
